import { EstimationVariancePoint } from '@/features/TimeStatsModel';

export const KNOWN_STATUS_COLORS: Record<string, string> = {
  open: '#ff0000',
  needInfo: '#ff8000',
  inProgress: '#ffd500',
  inReview: '#00ff2b',
  new: '#00eaff',
  paused: '#006aff',
  testing: '#1500ff',
  resolved: '#9500ff',
  closed: '#ff00ff',
  cancelled: '#ff0080',
};

const FALLBACK_STATUS_PALETTE = [
  '#b32d00',
  '#b37700',
  '#59b300',
  '#00b371',
  '#0077b3',
  '#001eb3',
  '#3b00b3',
  '#8f00b3',
  '#b30086',
  '#b3002d',
];

export type StatusLegendItem = {
  statusKey: string;
  label: string;
  color: string;
  count: number;
};

export function buildStatusLegend(points: EstimationVariancePoint[]): StatusLegendItem[] {
  const countByStatus = new Map<string, { label: string; count: number }>();

  points.forEach((point) => {
    const existing = countByStatus.get(point.statusKey);

    if (existing) {
      existing.count += 1;

      return;
    }

    countByStatus.set(point.statusKey, { label: point.statusDisplay, count: 1 });
  });

  const knownEntries = Object.keys(KNOWN_STATUS_COLORS)
    .filter((statusKey) => countByStatus.has(statusKey))
    .map((statusKey) => ({ statusKey, ...countByStatus.get(statusKey)! }));

  const unknownEntries = [...countByStatus.entries()]
    .filter(([statusKey]) => !(statusKey in KNOWN_STATUS_COLORS))
    .map(([statusKey, value]) => ({ statusKey, ...value }))
    .sort((a, b) => a.label.localeCompare(b.label));

  const unknownWithColors = unknownEntries.map((entry, index) => ({
    ...entry,
    color: FALLBACK_STATUS_PALETTE[index % FALLBACK_STATUS_PALETTE.length],
  }));

  const knownWithColors = knownEntries.map((entry) => ({
    ...entry,
    color: KNOWN_STATUS_COLORS[entry.statusKey],
  }));

  return [...knownWithColors, ...unknownWithColors];
}
